import React from 'react';
import { useAccessControl } from '../../hooks/useAccessControl';
import PendingVerificationNotice from './PendingVerificationNotice';

interface VerifiedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const VerifiedRoute: React.FC<VerifiedRouteProps> = ({ 
  children, 
  fallback 
}) => {
  const { canAccess, requiresVerification, userRole } = useAccessControl();

  // If user doesn't require verification, show the content
  if (!requiresVerification) {
    return <>{children}</>;
  }

  // If user requires verification but is verified, show the content
  if (canAccess) {
    return <>{children}</>;
  }

  // If user requires verification but is not verified, show pending notice
  if (fallback) {
    return <>{fallback}</>;
  }

  return <PendingVerificationNotice userRole={userRole || undefined} />;
};

export default VerifiedRoute;
